// extracted by mini-css-extract-plugin
export default {"content":"Introduce_content__7qZ+4"};